import getLogger from "utils/logger.util";

import {
  FETCH_SYSTEMS_FAIL,
  FETCH_SYSTEMS_START,
  FETCH_SYSTEMS_SUCCESS,
  RESET_SYSTEMS,
  UPDATE_SYSTEM_CONNECTION_STATUS,
  UPDATE_SYSTEMS
} from "../actionTypes/systemsAndLiveAlarms";

const Logger = getLogger("System Store");

const initialState = {
  systems: [],
  systemsAsObj: {},
  fetching: true,
  error: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SYSTEMS_START:
      return fetchSystemsStart(state);
    case UPDATE_SYSTEM_CONNECTION_STATUS:
      return updateSystemsStatus(state, action.payload);
    case UPDATE_SYSTEMS:
      return updateSystems(state, action.payload);
    case FETCH_SYSTEMS_SUCCESS:
      return fetchSystemsSuccess(state, action);
    case FETCH_SYSTEMS_FAIL:
      return fetchSystemsFail(state, action);
    case RESET_SYSTEMS:
      return initialState;
    default:
      return state;
  }
};

function updateSystemsStatus(state, payload) {
  const { system, updatedData } = payload;
  const { systemsAsObj } = state;
  for (const [key, value] of Object.entries(systemsAsObj)) {
    if (key.includes(system)) {
      Logger.log(`updateSystemsStatus - sys id in store: ${key}, received on WS:${system}, and data: `, updatedData);
      systemsAsObj[key] = { ...value, ...updatedData };
    }
  }
  return { ...state, systemsAsObj };
}

function updateSystems(state, payload) {
  const { system, updatedData } = payload;
  const { systemsAsObj } = state;
  const updatedSystem = systemsAsObj[system];
  systemsAsObj[system] = { ...updatedSystem, ...updatedData };
  return { ...state, systemsAsObj };
}

function fetchSystemsStart(state) {
  return {
    ...state,
    fetching: true,
    error: null
  };
}

function convertSysListToObj(system) {
  return system.reduce((accumulatedVal, current) => {
    accumulatedVal[current.sysId] = current;
    return accumulatedVal;
  }, {});
}

const formatVal = val => (val !== null ? val : "-");

function fetchSystemsSuccess(state, action) {
  const systems = action.payload.systems.map(system => {
    const production = formatVal(system.production);
    const recovery = formatVal(system.recovery);
    const conductivity = formatVal(system.conductivity);
    return { ...system, production, recovery, conductivity };
  });
  return {
    ...state,
    systems: action.payload.systems,
    systemsAsObj: convertSysListToObj(systems),
    fetching: false,
    error: null
  };
}

function fetchSystemsFail(state, action) {
  return {
    ...state,
    fetching: false,
    error: action.payload.error.message
  };
}

export default reducer;
